// extracted by mini-css-extract-plugin
module.exports = {"nodata-wrapper":"style_nodata-wrapper__Tp6ce","nodataWrapper":"style_nodata-wrapper__Tp6ce","box":"style_box__q00nT","big":"style_big__Pezgz"};